import { AuthStore, getLocalJwtFromSessionStorage, TokenResponse } from 'auth';

export const getAuthHeader = (
  bffApiUrl: string,
  configureAccessToken: boolean | undefined,
  localJwtProvider: string | undefined,
  authToken?: TokenResponse | undefined
): string => {
  if (!configureAccessToken) return '';

  const token = authToken ?? AuthStore.getAuthToken();
  if (!token) return '';

  const isLocalJwtNeeded =
    (bffApiUrl.startsWith('http://localhost') || bffApiUrl.startsWith('https://localhost')) &&
    !!localJwtProvider;

  if (isLocalJwtNeeded) {
    const localJwtAuthHeader = getLocalJwtFromSessionStorage();
    return localJwtAuthHeader ?? '';
  }

  const gatewayAuthHeader = `${token.token_type} ${token.access_token}`;
  return gatewayAuthHeader;
};
